export const ACCESS_TOKEN = 'accessToken'
export const REFRESH_TOKEN = 'refreshToken'
export const LOCALE_KEY = 'locale'
export const LOCAL_PROMPT_KEY = 'localPrompt'
export const DIRECT_LOGIN = 'directLogin'
